import styled from "styled-components";
import { Swiper } from "swiper/react/swiper-react";

export const WallboardSwiper = styled(Swiper)`
  padding: 4rem 0;
  .swiper-pagination-bullet {
    border: var(--field-color) 1px solid;
    height: 10px;
    width: 10px;
    opacity: 1;
    background-color: transparent;
    @media screen and (max-width: 768px) {
      height: 6px;
      width: 6px;
    }
    &.swiper-pagination-bullet-active {
      background-color: var(--field-color);
    }
  }
`;

export const WallboardCard = styled.div`
  padding: 1.5rem 3rem;
  min-width: 160px;
  box-shadow: 0px 3px 10px 0px rgba(62, 165, 219, 0.08);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  @media screen and (max-width: 768px) {
    padding: 1rem;
    border-radius: 6px;
    img {
      width: 36px;
      height: 36px;
    }
  }
`;

export const WallBoardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 500;
  color: var(--text-color-dark);
  strong {
    font-size: var(--font-size-xxl);
  }
  @media screen and (max-width: 992px) {
    strong {
      font-size: var(--font-size-base);
    }
    span {
      font-size: var(--font-size-xs);
    }
  }
`;
